module.exports = __webpack_public_path__ + "static/media/zs-donum-felix.12769e52.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/sponsors/zs-donum-felix.png
// module id = 509
// module chunks = 0